import React from "react";
import { Modal, Button } from "react-bootstrap";

const ConfirmationModal = props => {
  const { title, primaryActionCaption, primaryActionFn, secondaryActionCaption = 'Abbrechen', visible, closeFn } =
    props;

  return (
    <Modal show={visible} onHide={closeFn}>
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {props.children}
      </Modal.Body>

      <Modal.Footer>
        <Button className="btn btn-secondary" onClick={primaryActionFn}>
          {primaryActionCaption}
        </Button>

        {secondaryActionCaption !== false && (
          <Button onClick={closeFn}>
            {secondaryActionCaption}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;
